module.exports = __webpack_public_path__ + "img/Docker64_48.2e01c5b5.png";